/**
 * Admin Layout Component
 * iOS/SaaS style design from GPT.html
 */

import { Outlet, NavLink } from 'react-router-dom'
import {
  Home,
  ClipboardList,
  Users,
  Wallet
} from 'lucide-react'
import { cn } from '@/lib/utils'

const navItems = [
  { to: '/admin', icon: Home, label: 'Главная' },
  { to: '/admin/orders', icon: ClipboardList, label: 'Заказы' },
  { to: '/admin/masters', icon: Users, label: 'Мастера' },
  { to: '/admin/finance', icon: Wallet, label: 'Финансы' },
]

export function Layout() {
  return (
    <div className="flex h-full flex-col bg-slate-50">
      {/* Header - Glassmorphism style */}
      <header className="sticky top-0 z-50 safe-area-top">
        <div className="bg-[var(--color-primary-strong)]/95 backdrop-blur-md shadow-md">
          <div className="px-4 py-3 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <img
                src={`${import.meta.env.BASE_URL}logo-icon.svg`}
                alt="Gasworkers"
                className="w-8 h-8"
              />
              <div>
                <h1 className="text-white font-bold text-lg leading-tight">Gasworkers</h1>
                <div className="flex items-center gap-1.5">
                  <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                  <span className="text-blue-100 text-xs font-medium">Система активна</span>
                </div>
              </div>
            </div>
            {/* User Avatar */}
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center border border-white/30">
              <span className="text-white text-sm">👤</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-auto px-4 py-4 safe-area-bottom pb-20">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <div className="safe-area-bottom">
          <div className="flex justify-around items-center h-16 max-w-md mx-auto px-2">
            {navItems.map(({ to, icon: Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/admin'}
                className={({ isActive }) =>
                  cn(
                    'flex flex-col items-center gap-1 w-16 py-2 rounded-xl transition-all',
                    isActive
                      ? 'text-primary'
                      : 'text-slate-400 hover:text-slate-600'
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon
                      className={cn(
                        'h-6 w-6 transition-transform',
                        isActive && 'transform -translate-y-0.5'
                      )}
                    />
                    <span className="text-[10px] font-medium">{label}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      </nav>
    </div>
  )
}
